export function Button(props: {label: string, aria_label?: string, className?: string, icon_left_class?: string, icon_right_class?: string, disabled?: boolean, onClick: () => void}){
  return <button
          type="button"
          aria-label={props.aria_label ? props.aria_label : props.label}
          aria-disabled={props.disabled} 
          tabIndex={0} 
          className={"btn step_buttons__button " + (props.disabled ? " btn--disabled " : '') +  (props.className || "")} 
          onClick={ (_) => {
            if(props.disabled){return;}
            props.onClick()
          }}

          onKeyUp={ (event) => {
            if(props.disabled){return;}
            if ((event.code != " ")  && (event.code != "Enter")) { return } 
            props.onClick();
          }}
        >
            {props.icon_left_class && <div aria-hidden className={"icon " + props.icon_left_class}></div>}
            <span aria-hidden>{props.label}</span>
            {props.icon_right_class && <div aria-hidden className={"icon " + props.icon_right_class}></div>}
        </button>;
  }